import * as React from 'react';
function SvgCustomSort(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentcolor"
      className="custom-sort_svg__fil-icon"
      {...props}
    >
      <path d="M5.75 3.5v17M2 7.158L5.75 3.5 9.5 7.158M18.25 20.5v-17M14.5 16.842l3.75 3.658L22 16.842" />
    </svg>
  );
}
export default SvgCustomSort;
